// extracted by mini-css-extract-plugin
export default {"image":"n4-z","loaded":"o4-z"};